import { memoize } from '@luminovo/commons';

// Annotated: the inferred type names lodash's `MemoizedFunction`, which needs `@types/lodash`.
export const getOrCreateNumberFormatter: (locale: string, opts?: Intl.NumberFormatOptions) => Intl.NumberFormat =
    memoize(
        function getOrCreateNumberFormatter(locale: string, opts?: Intl.NumberFormatOptions): Intl.NumberFormat {
            return new Intl.NumberFormat(locale, opts);
        },
        (locale, opts) => JSON.stringify({ locale, opts }),
    );
